import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listBusinessMasters,
  updateBusinessMaster,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * BusinessMaster 更新 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * optimistic locking: expected_updated_at を request に含める。
 */
export function useUpdateBusinessMaster(): InvalidatingMutationResultFor<
  typeof updateBusinessMaster
> {
  return useInvalidatingMutation(updateBusinessMaster, [
    createConnectQueryKey({
      schema: listBusinessMasters,
      cardinality: 'finite',
    }),
  ])
}
